export default {
  brand: 'CryptoPay',
  transferHint: '請向以下地址轉帳',
  rechargeAmount: '充值金額',
  rechargeAddress: '充值地址',
  scanTip: '使用錢包掃碼完成轉帳',
  copy: '複製',
  copied: '已複製',
  copyFail: '複製失敗',
  networkFee: '網路手續費',
  eta: '預計到帳時間',
  etaVal: '5-15 分鐘',
  actualArrival: '實際到帳',
  noticeTitle: '充值須知',
  notice1: '請僅向當前頁面顯示的二維碼或地址轉帳，轉錯地址資產將無法找回。',
  notice2: '轉帳金額必須精準為 {amount} {coin}，金額不符將無法自動入帳。',
  notice3: '請等待區塊鏈節點確認（通常 1 次確認後自動到帳）。',
  notice4: '鏈上轉帳不可撤銷，因使用者操作失誤造成的損失需自行承擔。',
  selectLang: '選擇語言',
  back: '返回',
  pending: '待支付',
  paid: '已支付',
  timeout: '已逾時',
  orderNo: '訂單',
  loading: '載入中…',
  paramError: '連結參數不完整',
  initFail: '建立訂單失敗',
  paidSuccess: '支付成功',
  timedOut: '訂單已逾時，請重新發起'
}